var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { asTypeProxy, makePathModel } from '../../utils/nestedPathModel';
import { Schema } from '../../adapters/schema';
import { getTranslation } from '../../utils/translations';
import translations from './translations';
var t = getTranslation(translations);
export function makePostalAddressSubformModel(opts) {
    if (opts === void 0) { opts = {}; }
    t = __assign(__assign({}, t), (opts && opts.translationsOverride));
    var initialValues = {};
    var fields = asTypeProxy();
    var PATHS = {
        POSTAL_CODE: fields.postalCode,
        CITY: fields.city,
        STREET: fields.street,
        HOUSE_NUMBER: fields.houseNumber,
    };
    var _a = makePathModel(PATHS), paths = _a[0], selectors = _a[1];
    var validationSchema = Schema.object().shape({
        postalCode: Schema.string()
            .label(t.postalCodeLabel)
            .trim()
            .required()
            .min(3),
        city: Schema.string().label(t.cityLabel).trim().required(),
        street: Schema.string().label(t.streetLabel).trim().required(),
        houseNumber: Schema.string()
            .label(t.houseNumberLabel)
            .trim()
            .required()
            .max(10),
    });
    return {
        paths: paths,
        selectors: selectors,
        initialValues: initialValues,
        validationSchema: validationSchema,
    };
}
